<template>
  <div id="compreSportsMeet_delegation" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        :inputObject="select_opt_inputObject"
        @inputValEvent="inputValHandler"
      ></marathon_select_opt>
    </div>
    <div class="teamTable">
      <div class="tableScrollArea" ref="tableParentDom">
        <div class="match_label_fixed" v-show="curMatchLabelFixedIcon">
          <div class="match_label">
            <span class="label_textArea">
              <!-- <span class="labelIcon">
                <img :src="currBigSports.icon" />
              </span> -->
              <span
                :class="[
                  currBigSports.label && currBigSports.label.length === 2
                    ? 'letterSpa'
                    : '',
                ]"
                v-text="currBigSports.label"
              ></span>
            </span>
          </div>
        </div>
        <div :class="scrollDomClassName">
          <delegation_groupItem
            v-for="item in matchList"
            :currCid="currCid"
            :key="item.icon"
            :data="item"
            :pbPx="matchItemPbpx"
          ></delegation_groupItem>
        </div>
        <p class="loadingClass" v-show="loading">加载中...</p>
        <p class="noDataClass" v-show="noData">暂无数据</p>
      </div>
    </div>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
  </div>
</template>

<script>
import { https_delegationList } from '@api/platfrom_compreSportsMeet_api'
import BackTop from '@components/base/backTop.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import delegation_groupItem from '@components/platfromBase/compreSportsMeet/delegation_groupItem.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'compreSportsMeet_delegation',
  components: {
    marathon_select_opt,
    delegation_groupItem,
    BackTop,
  },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      select_opt_inputObject: {
        inputTitle: '国家/地区',
        placeholder: '请输入代表团名称',
        iconType: 'country',
      }, //控制marathon_select_opt中的输入框是否显示
      isScrollBottom: false,
      scrollDomClassName: 'scrollDomContain',
      scrollDomById: 'containerFull_body',
      loading: false,
      curMatchLabelFixedIcon: null,
      matchItemPbpx: 0,
      matchLabelArr: [],
      matchList: null,
      curInputVal: '',
      selectOptData: {
        configArr: [],
        selectOpt_list: [],
      },
      showBackTop: false,
    }
  },
  beforeCreate() {},
  created() {
    this.initPbPx()
    this.init()
  },
  beforeDestroy() {
    // window.removeEventListener('resize', () => {
    //   this.onResizeEvent()
    // })
    window.removeEventListener('scroll', () => {
      this.scrollListenerEvent()
    })
  },
  computed: {
    currBigSports() {
      return {
        label: this.curMatchLabelFixedIcon,
        icon: this.curMatchLabelFixedIcon,
      }
    },
    noData() {
      return this.matchList && this.matchList.length == 0
    },
    tableHeightPx() {
      let clientHeight = window.innerHeight
        ? window.innerHeight
        : window.screen.height
        ? window.screen.height
        : 667
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375

      return Math.floor(clientHeight - (clientWidth / 100) * (42 - 26))
      // return 500
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      console.debug(this.currCid, this.currSid)
      await this.getDelegationList()
      console.debug(this.stageArr)

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    inputValHandler(inputVal) {
      // 获取inputVal值
      console.debug('inputVal:', inputVal)
      this.curInputVal = inputVal
      this.getDelegationList()
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    scrollListenerEvent() {
      const scrollTop = this.scrollAreaDom.scrollTop
      const scrollHeight = this.scrollAreaDom.scrollHeight
      const parentHeightPx = this.scrollAreaDom.offsetHeight
      let direction = this.DIRECTION_ENUM.DOWN
      if (this.beforeScrollTop > scrollTop) {
        direction = this.DIRECTION_ENUM.UP
      }
      // 通过滚动方向判断是触底还是触顶
      // console.debug(
      //   'direction:',
      //   direction,
      //   scrollTop,
      //   parentHeightPx,
      //   scrollHeight,
      //   this.isScrollBottom
      // )
      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }

      this.changeMatchLabelFixed(scrollTop, direction)

      if (direction == this.DIRECTION_ENUM.DOWN) {
        // 滚动触底
        if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
          console.debug('滚动触底')
          this.isScrollBottom = true
        }
      } else {
        // 滚动到顶部
        this.isScrollBottom = false
        if (scrollTop <= this.threshold) {
          console.debug('滚动到顶部')
        }
      }

      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }
      this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      console.debug(
        'this.parentWidthPx:',
        this.$refs.tableParentDom.scrollHeight
      )
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      // window.addEventListener('resize', () => {
      //   this.onResizeEvent()
      // })
      // this.scrollAreaDom = document.getElementsByClassName(
      //   `${this.scrollDomClassName}`
      // )[0]
      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      // console.debug(this.scrollAreaDom)
      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    changeMatchLabelFixed(valPx, direction) {
      let scrollMatchItemHeightArr = this.scrollMatchItemHeightArr || []
      let curMatchLabelFixedIcon = null
      for (let i = 0; i < scrollMatchItemHeightArr.length; i++) {
        const item = scrollMatchItemHeightArr[i]
        if (item.heightPx > valPx && valPx <= item.heightPx) {
          if (item.heightPx - this.matchItemPbpx < valPx) {
            curMatchLabelFixedIcon = null
          } else {
            curMatchLabelFixedIcon = item.icon
          }
          break
        }
      }
      // console.debug(
      //   'curMatchLabelFixed:',
      //   scrollMatchItemHeightArr,
      //   curMatchLabelFixedIcon,
      //   valPx,
      //   direction
      // )
      this.curMatchLabelFixedIcon = curMatchLabelFixedIcon
    },
    getScheduleMatchListDomHeigt() {
      let scrollMatchItemHeightArr = []
      let curHeightPx = 0
      const matchList = this.matchList
      matchList.forEach((item) => {
        let dom = document.getElementById(`matchList_${item.icon}`)
        curHeightPx += dom.offsetHeight //里面含paddingBottom值了
        scrollMatchItemHeightArr.push({
          icon: item.icon,
          heightPx: curHeightPx,
        })
      })
      console.debug('getScheduleMatchListDomHeigt:', scrollMatchItemHeightArr)
      this.scrollMatchItemHeightArr = scrollMatchItemHeightArr
    },
    initPbPx() {
      this.matchItemPbpx = Math.ceil(2.78 * this.vw2px)
    },
    // onResizeEvent() {
    //   this.initPbPx()
    //   if (this.$refs.tableParentDom) {
    //     this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
    //   } else {
    //     console.debug('dom 不存在')
    //   }
    // },
    computedMatchList(group) {
      console.debug('computedMatchList:', group)
      let matchLabelArr = this.matchLabelArr
      let matchList = []
      if (group && group.length > 0) {
        matchList = group.map((item) => {
          return {
            label: item.initial,
            icon: item.initial,
            list: item.datas,
          }
        })
        this.matchList = matchList
        this.matchLabelArr = matchLabelArr
        console.debug('computedMatchList end:', matchList, matchLabelArr)
      }
    },
    async getDelegationList() {
      await https_delegationList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        name: this.curInputVal,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              this.computedMatchList(res.data)
              this.initScroll()
            } else {
              console.debug('暂无数据')
            }
            console.debug(
              '暂无数据:',
              this.matchTotal,
              this.matchList,
              this.matchList.length
            )
            this.$nextTick(() => {
              this.loading = false
              this.getScheduleMatchListDomHeigt()
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_delegation {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .teamTable {
    padding: 2.778vw 0 6.964vw;
    .tableScrollArea {
      position: relative;
      .match_label_fixed {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 3.472vw;
        background-color: var(--mixtmt_whiteColor);
        .match_label {
          width: 100%;
          height: 3.472vw;
          background-image: var(--mixtmt_scheduleMatchList_dateBg);
          background-size: 100% auto;
          background-position: left top;
          background-repeat: no-repeat;

          .label_textArea {
            position: absolute;
            left: 0;
            top: 0.347vw;
            z-index: 2;
            width: 21.55%;
            padding-top: 0.6%;
            font-size: 1.38vw;
            color: var(--mixtmt_whiteColor);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            .labelIcon {
              width: 1.8vw;
              height: 1.8vw;
              overflow: hidden;
              margin-right: 0.694vw;
              background-color: #ccc;
            }
            & .letterSpa {
              letter-spacing: 0.4vw;
            }
          }
        }
      }
      /* .scrollDomContain {
        max-height: calc(100vh - 19.142vw);
        overflow: auto;
      } */
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}
</style>
